
import Vue from 'vue';
import Button from '@/components/Button/index.vue';
import Modal from '@/components/Modal/index.vue';
import { AgentParms, createAgent } from '@/services/territory-access/create-agent';
import {
  createTerritory,
  CreateTerritoryParams,
} from '@/services/territory-access/create-territory';
import { getReport, GetReportParms } from '@/services/territory/get-report';
import { insertStepRegister, InsertStepRegisterParams } from '@/services/step-register/insert-step-register';
import { updateStatusTerritoryOfficial } from '@/services/territory/update-status-territory-oficial';
import { ImgContainer, ImgRetry } from './styles';

export default Vue.extend({
  components: {
    ImgContainer,
    ImgRetry,
    Button,
    Modal,
  },
  inject: [
    'userLogged',
    'getStepDate',
    'resetStepsRegisterTerritory',
    'changeStatusTerritoryCarRequest',
  ],
  data() {
    return {
      isLoadingNextStep: false,
      isLoadingImg: true,
      isOpenModalUnFit: false,
    };
  },
  methods: {
    async onNextStep() {
      try {
        this.isLoadingNextStep = true;
        await this.createAgentRequest();
        await this.createTerritoryRequest();
        updateStatusTerritoryOfficial(this.getStepDate.territory.id, 'PROVISORIO');
        await this.getReportRequest();
        this.changeStatusTerritoryCarRequest('PROVISORIO');
        await updateStatusTerritoryOfficial(this.getStepDate.territory.id, 'PROVISORIO');
        if (!this.isOpenModalUnFit) {
          this.getStepDate.currentStep += 1;
          await this.insertStepRegisterRequest();
        }
      } catch (err) {
        this.resetValues();
        this.getStepDate.isErrors = true;
      } finally {
        this.isLoadingNextStep = false;
      }
    },
    async createAgentRequest() {
      const { idUser, stName, stDocument } = this.userLogged;
      const params: AgentParms = {
        agents: [
          {
            nmAgent: stName,
            vlDocument: stDocument,
          },
        ],
        requestSource: {
          fkUser: idUser,
        },
      };

      const agentExist = await this.verifyAgentExist();

      if (agentExist) return;

      const response = await createAgent(params);

      if (response.hasErrors) {
        throw new Error();
      }

      const [agent] = response.agents;
      this.getStepDate.agent.id = agent.cdAgent;
    },
    async verifyAgentExist() {
      const { idUser, stName, stDocument } = this.userLogged;
      const params: AgentParms = {
        agents: [
          {
            nmAgent: stName,
            vlDocument: stDocument,
            dbOperation: 'Update',
          },
        ],
        requestSource: {
          fkSystem: '1',
          fkUser: idUser,
        },
      };

      const response = await createAgent(params);

      if (response.hasErrors) {
        throw new Error();
      }

      if (response) {
        const [agent] = response.agents;

        const isEqual = agent.vlDocument === stDocument;

        if (isEqual) {
          this.getStepDate.agent.id = agent.cdAgent;
          return true;
        }
      }

      return false;
    },
    async createTerritoryRequest() {
      const { stName, stDocument } = this.userLogged;

      const params: CreateTerritoryParams = {
        car: this.getStepDate.territory.car,
        cdAgent: this.getStepDate.agent.id,
        nmAgent: stName,
        vlDocument: stDocument,
        ownerCode: this.generateRandomCode(),
        geom: this.getStepDate.territory.geometry,
        cdCity: Number(this.getStepDate.territory.codCounty),
        // @ts-ignore
        name: this.getStepDate.territory.name,
        integrationCode: this.userLogged.idUser.toString(),
      };

      const response = await createTerritory(params);

      if (response.hasErrors) {
        throw new Error();
      }

      const { agentTerritory } = response;
      const [agent] = agentTerritory;

      this.getStepDate.territory.id = agent.territory.cdTerritory;
      this.getStepDate.agent.document = agent.agents[0].vlDocument;
    },
    async getReportRequest() {
      const { idUser } = this.userLogged;
      const params: GetReportParms = {
        tokenKey: this.userLogged.company.stKey,
        cdTerritory: this.getStepDate.territory.id,
        cdUser: idUser,
      };

      const data = await getReport(params);

      if (data.hasErrors) {
        throw new Error();
      }

      const CAR_FIT = 'Apto';

      if (data.status === CAR_FIT) {
        this.isOpenModalUnFit = true;
      }
      this.getStepDate.report = { ...this.getStepDate.report, ...data };
    },
    async insertStepRegisterRequest() {
      const data: InsertStepRegisterParams = {
        currentStep: this.getStepDate.currentStep,
        cdUser: this.userLogged.idUser,
        cdTerritory: this.getStepDate.territory.id,
        cdAgent: this.getStepDate.agent.id,
        tokenKey: this.userLogged.company.stKey,
      };

      await insertStepRegister(data);
    },
    generateRandomCode() {
      const { stDocument } = this.userLogged;
      const FIRST_FOUR_CHAR_CAR = this.getStepDate.territory.car.substring(0, 4);
      const FIRST_FOUR_CHAR_CPF = stDocument.substring(0, 4);
      const randomValue = Math.floor(1000 + Math.random() * 9000);

      return FIRST_FOUR_CHAR_CAR + FIRST_FOUR_CHAR_CPF + randomValue;
    },
    resetValues() {
      this.isOpenModalUnFit = false;
      this.getStepDate.currentStep -= 1;
      this.getStepDate.territory.car = '';
      this.getStepDate.territory.name = '';
    },
    onRetryImg() {
      this.getStepDate.img.url += `?${new Date().getTime()}`;
    },
  },
});
